import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    ModalOverlay,
    ModalContent,
    ModalTitle,
    ModalText,
    ModalHighlight,
    ModalButtons,
    PrimaryButton,
    SecondaryButton,
    CloseButton,
    IconWrapper
} from './styled';

const FreeLimitModal = ({ show, onClose, characterName, remaining = 0 }) => {
    const history = useHistory();

    if (!show) return null;

    const handleUpgrade = () => {
        onClose();
        history.push('/dashboard/sign');
    };

    const isLimitReached = remaining === 0;

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={onClose}>&times;</CloseButton>
                
                <IconWrapper>
                    {isLimitReached ? '🚫' : '⚠️'}
                </IconWrapper>
                
                <ModalTitle>
                    {isLimitReached 
                        ? 'Limite Diário Atingido!' 
                        : 'Atenção: Limite Próximo!'}
                </ModalTitle>
                
                <ModalText>
                    {isLimitReached ? (
                        <>
                            Você já usou suas <ModalHighlight>20 mensagens</ModalHighlight> gratuitas
                            com <ModalHighlight>{characterName || 'este personagem'}</ModalHighlight> hoje.
                        </>
                    ) : (
                        <>
                            Você tem apenas <ModalHighlight>{remaining} {remaining === 1 ? 'mensagem' : 'mensagens'}</ModalHighlight> restantes 
                            com <ModalHighlight>{characterName || 'este personagem'}</ModalHighlight> hoje.
                        </>
                    )}
                </ModalText>
                
                <ModalText>
                    {isLimitReached ? (
                        <>
                            💎 Com o <strong>Plano Premium</strong>, você pode conversar sem limites 
                            com todos os personagens!
                        </>
                    ) : (
                        <>
                            Aproveite ao máximo! Depois você pode assinar para ter conversas ilimitadas.
                        </>
                    )}
                </ModalText>

                <ModalButtons>
                    {isLimitReached && (
                        <PrimaryButton onClick={handleUpgrade}>
                            Ver Planos Premium
                        </PrimaryButton>
                    )}
                    <SecondaryButton onClick={onClose}>
                        {isLimitReached ? 'Voltar' : 'Entendi'}
                    </SecondaryButton>
                </ModalButtons>
                
                {isLimitReached && (
                    <ModalText style={{ fontSize: '14px', marginTop: '15px', color: '#999' }}>
                        💡 <strong>Dica:</strong> O limite é resetado diariamente às 00h
                    </ModalText>
                )}
            </ModalContent>
        </ModalOverlay>
    );
};

export default FreeLimitModal;
